import React, { FunctionComponent, SVGProps } from "react";

export const PrinterIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M5.25 3.75A.75.75 0 0 1 6 3h12a.75.75 0 0 1 .75.75v3h1c1.253 0 2.374.952 2.374 2.25v7.5a.75.75 0 0 1-.75.75H18.75v3.375a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V17.25H2.624a.75.75 0 0 1-.75-.75V9c0-1.298 1.121-2.25 2.375-2.25h1v-3Zm-1 4.5c-.542 0-.876.391-.876.75v6.75H5.25v-1.5A.75.75 0 0 1 6 13.5h12a.75.75 0 0 1 .75.75v1.5h1.875V9c0-.359-.334-.75-.875-.75H4.25Zm13-1.5H6.75V4.5h10.5v2.25Zm0 8.25H6.75v4.875h10.5V15Zm-1.5-4.125a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0Zm1.875-.375a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
